import { ErrorMessage } from "../types";

export function isErrorMessage(error: any): error is ErrorMessage {
    return error && (error.error !== undefined || error.reason !== undefined);
}

export class UsernameExistsException extends Error {
    constructor(message?: string) {
        super(message);
        // The following two lines are needed as the current TypeScript transpiles down to ES5, which does not fully support classes
        Object.setPrototypeOf(this, UsernameExistsException.prototype);
        this.name = 'UsernameExistsException';
    }
}

export class APIError extends Error {
    constructor(public errorMessage: ErrorMessage) {
        super(errorMessage.error);
    }
}  